import { render, staticRenderFns } from "./InitView.vue?vue&type=template&id=8255d31e"
import script from "./InitView.vue?vue&type=script&lang=js"
export * from "./InitView.vue?vue&type=script&lang=js"
import style0 from "./InitView.vue?vue&type=style&index=0&id=8255d31e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports